import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import { useTranslation } from "../../i18n/translate"
import InfoIcon from "../../images/icons/info.svg"
import useIsClient from "../../util/is-client"
import "./form-error-banner.sass"

const FormErrorBanner = ({
  textTranslatedString,
  children,
  emailAddress,
  ...props
}) => {
  const { t } = useTranslation()

  /// Exceptions

  if (props.textTranslationKey) {
    throw new Error('prop "textTranslationKey" is deprecated')
  }

  //
  const isClient = useIsClient()

  return (
    <div className={classNames("_fp-form-error-banner _fp-print-hidden")}>
      <div className="_fp-form-error-banner__icon">
        <InfoIcon />
      </div>
      <div className="_fp-form-error-banner__content">
        <p className="_fp-text">{textTranslatedString}</p>
        {isClient && (
          <a className={"_fp-text-link"} href={"mailto:" + emailAddress}>
            {emailAddress}
          </a>
        )}
      </div>
    </div>
  )
}

FormErrorBanner.propTypes = {
  textTranslatedString: PropTypes.node,
  emailAddress: PropTypes.string,
}

export default FormErrorBanner
